import { KeyboardEvent, ReactElement } from "react";
import Modal from "@ingka/modal";
import "@ingka/svg-icon/dist/style.css";
import "@ingka/button/dist/style.css";
import "@ingka/modal/dist/style.css";
import "@ingka/focus/dist/style.css";
import "@ingka/text/dist/style.css";

interface FixaModalProps {
  children: ReactElement[] | ReactElement;
  handleCloseBtn: () => void;
  visible?: boolean;
  className?: string;
  keepContentMounted?: boolean;
  focusLockProps?: { locked: boolean };
  onModalOpened?: (e: AnimationEvent) => void;
  escapable?: boolean;
  onKeyDown?: (e: KeyboardEvent) => void;
  onEscape?: () => void;
  "data-testid"?: string | undefined;
}

const NEVER_PRESSED_KEY = { key: "Unidentified", shift: false, ctrl: false };

export const FixaModal = (props: FixaModalProps) => {
  const { children, onEscape, focusLockProps, ...rest } = props;

  const handleKeyDownCapture = (e: KeyboardEvent<HTMLElement>) => {
    const target = e.target as HTMLElement;
    if (
      e.key === "Escape" &&
      target.closest?.(".modal-wrapper") === e.currentTarget
    ) {
      e.preventDefault();
      e.stopPropagation();
      onEscape?.();
    }
  };

  return (
    <Modal
      {...rest}
      {...(onEscape && {
        onKeyDownCapture: handleKeyDownCapture,
        focusLockProps: { ...focusLockProps, escapeHotkey: NEVER_PRESSED_KEY },
      })}
      {...(!onEscape && { focusLockProps })}
    >
      {children}
    </Modal>
  );
};
